import { z } from "zod";

export const districtNameSchema = z.string().min(1).brand<"DistrictName">();
export type DistrictName = z.infer<typeof districtNameSchema>;
